import React, { useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import CreateInvoiceSearchFilters from "./CreateInvoiceSearchFilters";
import moment from "moment";
import { getErrorMessage, mustBeArray, requestHasError } from "../../utils/lib";
import { BASE_URL, DEFAULT_DATE_FORMAT } from "../../constants";
import { loadClients } from "../../actions/clientActions";
import MYOBInvoiceList from "./InvoiceList";
import { toastr } from "react-redux-toastr";
import { push } from "../../utils/navigation";
import InvoiceCreateErrorsModal from "./InvoiceCreateErrorModal";
import _ from "lodash";
import { createInvoice, getDeliveriesForInvoicing, getDeliveriesForInvoicingAsCsv } from "../../actions/myobActions";
import { isAxiosError } from "axios";

const MYOBCreate = () => {
  const [saving, setSaving] = useState(false);
  const [searching, setSearching] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [validationErrors, setValidationErrors] = useState(null);
  const [hasValidationErrors, setHasValidationErrors] = useState(false);
  const [filters, setFilters] = useState({
    from: null,
    to: null,
    clientIds: [],
  });
  const [invoiceDate, setInvoiceDate] = useState(
    moment().format(DEFAULT_DATE_FORMAT)
  );
  const [invoiceList, setInvoiceList] = useState([]);

  const dispatch = useDispatch();

  useEffect(() => {
    if (validationErrors) {
      setHasValidationErrors(true);
    }
  }, [validationErrors]);

  const onModalDismiss = () => {
    setHasValidationErrors(false);
    setValidationErrors(null);
  };

  const onCsvExport = async () => {
    await getDeliveriesForInvoicingAsCsv({
      dateFrom: filters.from,
      dateTo: filters.to,
      clientIds: filters.clientIds
    });
    toastr.success("Report generated");
  };

  const onFiltersChanged = (updatedFilters) => {
    setFilters(updatedFilters);
  };

  useEffect(() => {
    dispatch(loadClients("",false, true, true));
  }, []);

  const onInvoiceDateChanged = (value) => {
    setInvoiceDate(value);
  };

  const onSelectionsChanged = (selections) => {
    setSelectedRows(selections);
  };

  const onCreate = async () => {
    setSaving(true);
    if (_.isEmpty(selectedRows)) {
      setSaving(false);
      toastr.error("Please select at least one Location.");
      return;
    }

    try {
      await createInvoice({
        invoiceDate,
        from: filters.from,
        to: filters.to,
        locationIds: selectedRows
      });
      toastr.success("Invoices Created.");
      dispatch(push(`${BASE_URL}/invoice`));
    } catch (error) {
      if(isAxiosError(error)) {
        setValidationErrors(error.response.data.errors);
      }
    } finally {
      setSaving(false);
    }
  };

  const onCancel = () => {
    dispatch(push(`${BASE_URL}/invoice`));
  };

  const onSearch = async () => {
    setSelectedRows([]);
    setSearching(true);
    try {
      const response = await getDeliveriesForInvoicing({
        dateFrom: filters.from,
        dateTo: filters.to,
        clientIds: filters.clientIds
      });
  
      setInvoiceList(response);
    } catch (error) {
      console.log(error);
    } finally {
      setSearching(false);
    }
  };
  
  return (
    <React.Fragment>
      <div className={"row"}>
        <div className={"col-12"} style={{ marginBottom: "24px" }}>
          <h4>Create Invoice</h4>
        </div>
      </div>
      <CreateInvoiceSearchFilters
        onFilterChanged={onFiltersChanged}
        onInvoiceDateChanged={onInvoiceDateChanged}
        onSearch={onSearch}
        onCsvExportRequested={onCsvExport}
      />
      <div className="clearfix" />
      <MYOBInvoiceList
        onRowSelectionChanged={onSelectionsChanged}
        rows={invoiceList}
        searching={searching}
        showGstAndSubTotal={true}
      />
      <div className="mt-2 mb-2">
        <button
          className={`btn btn-primary ${
            saving ? "no-pointer-events" : ""
          }`}
          disabled={saving}
          onClick={onCreate}
        >
          <i className="fa fa-floppy-o" aria-hidden="true"></i> &nbsp;
          {saving ? "Creating..." : "Create Invoices"}
        </button>
        <button className="btn btn-default ml-1" onClick={onCancel}>
          <i className="fa fa-arrow-left" aria-hidden="true"></i> &nbsp;Cancel
        </button>
        <div className="clearfix" />
      </div>

      <InvoiceCreateErrorsModal
        visible={hasValidationErrors}
        errors={validationErrors}
        onClose={onModalDismiss}
      />
    </React.Fragment>
  );
};

export default MYOBCreate;
